import apiInstance from '../config/api/axios'

export const getKycEmailOtp = async(payload) => {
  const response = await apiInstance.post('/get-kyc-email-otp', payload)
  return response
}

export const verifyKycEmailOtp = async(payload) => {
  const response = await apiInstance.post('/verify-kyc-email-otp', payload)
  return response
}

export const postPersonalDetails = async(payload) => {
  const response = await apiInstance.post('/v2/borrower/personal-detail', payload)
  return response
}

export const getPiiData = async(payload) => {
  const response = await apiInstance.post('/get-pii-data', payload)
  return response
}

export const createDigiLocker = async(payload) => {
  const response = await apiInstance.post('/common/create-digilocker-request', payload)
  return response
}

export const getdownloadAadhaarData = async(payload) => {
  const response = await apiInstance.post('/common/download-aadhaar-data', payload)
  return response
}

export const saveBankDetails = async(payload) => {
  const response = await apiInstance.post('/api/borrower/save-bank-detail', payload)
  return response
}

export const ckycDetailsSearch = async(payload) => {
  const response = await apiInstance.get('/ckyc/search', payload)
  return response
}

export const CPSearchckycDetails = async(payload) => {
  // const response = await apiInstance.get(`/autopay/mandate/status/${payload?.merchant_order_id}`);
  // const response = await apiInstance.get('cp/ckyc/search', payload)
  // const response = await apiInstance.get(`/cp/ckyc/search-mobile?mobile/${payload?.mobile}`);

  const response = await apiInstance.get(
    `/cp/ckyc/search?mobile=${payload.mobile}`
  );
  // const response = await apiInstance.get(`/common/search-pincode?pincode=${payload.pincode}`, payload)

  // const response = await apiInstance.get(`/cp/ckyc/search?=${payload.mobile}`, payload)

  return response
}

export const CPckycOTP = async(payload) => {
  const response = await apiInstance.post('cp/ckyc/get_otp', payload)
  return response
}
// const response = await apiInstance.get(`/cp/ckyc/search?=${payload.mobile}`, payload)

export const saveDocsBorrower = async(payload) => {
  const formData = new FormData()
  formData.append('photo', payload?.photo)
  formData.append('pan_card', payload?.pan)
  formData.append('aadhaar_front', payload?.aadhaarFront)
  formData.append('aadhaar_back', payload?.aadhaarBack)
  formData.append('current_address_proof', payload?.current_address_proof)
  formData.append('mobile', payload?.mobile)
  formData.append('is_match', payload?.is_match)
  formData.append('match_grade', payload?.match_grade)
  formData.append('is_live', payload?.is_live)
  formData.append('verification_combined_status', payload?.verification_combined_status)
  formData.append('combined_msg', payload?.combined_msg)

  if (payload.employment_type === '4') {
    formData.append('gst_registration_certificate', payload.gst)
    formData.append('rbi_licence_copy', payload.rbi)
    formData.append('board_resolution', payload.boardResolution)
    formData.append('cob_certificate', payload.cobCertificate)
    formData.append('mem_art_association', payload.memAssociation)
    formData.append('incorp_certificate', payload.incorpCertificate)
    formData.append('bank_statement_1', payload.bankStatement)
  }
  if (payload.employment_type === '5') {
    formData.append('gst_registration_certificate', payload.gst)
    formData.append('additional_address_proof', payload.addressProof)
    formData.append('board_resolution', payload.boardResolution)
    formData.append('cob_certificate', payload.cobCertificate)
    formData.append('mem_art_association', payload.memAssociation)
    formData.append('incorp_certificate', payload.incorpCertificate)
    formData.append('bank_statement_1', payload.bankStatement)
    formData.append('udyam_certificate', payload.udyam_certificate)

  }
  if (payload.employment_type === '6') {
    formData.append('gst_registration_certificate', payload.gst)
    formData.append('udyam_certificate', payload.udyam_certificate)
    formData.append('reg_act_certificate', payload.reg_act_certificate)
    formData.append('bank_statement_1', payload.bankStatement)
  }
  if (payload.employment_type === '7' || payload.employment_type === '10' || payload.employment_type === '9') {
    formData.append('gst_registration_certificate', payload.gst)
    formData.append('reg_act_certificate', payload.reg_act_certificate)
    formData.append('udyam_certificate', payload.udyam_certificate)
    if(payload.employment_type === '7' || payload.employment_type === '10'){
      formData.append('partnership_deed', payload.partnership_deed)
    }
    if(payload.employment_type === '7'){
      formData.append('bank_statement_1', payload.bankStatement)
    }
  }
 
  if (payload.employment_type === '8') {
    formData.append('incorp_certificate', payload.incorpCertificate)
    formData.append('gst_registration_certificate', payload.gst)
    formData.append('udyam_certificate', payload.udyam_certificate)
    formData.append('cob_certificate', payload.cobCertificate)
    formData.append('employment_type', payload.employment_type)
    formData.append('company_buss_sector', payload.company_buss_sector)
  }
  const response = await apiInstance.post('/save-kyc-documents', formData)
  return response
}
export const verifyDoc = async(payload) => {
  const response = await apiInstance.get('/verify', payload)
  return response
}

export const getPaymentMethods = async(payload) => {
  const response = await apiInstance.get('/common/getPaymentMethods', payload)
  return response
}

export const generateOrder = async(payload) => {
  const response = await apiInstance.post('/common/generate-order', payload)
  return response
}

export const getPaymentStatus = async(payload) => {
  const response = await apiInstance.post('/common/check-payment-status', payload)
  return response
}

export const updateOrderStatus = async(payload) => {
  const response = await apiInstance.put('/common/update-order-status', payload)
  return response
}

export const userIdentyPhotoStatus = async(payload) => {
 
  const response = await apiInstance.put('/verify', payload)
  return response
}

export const getCKYCOTP = async(payload) => {

  const response = await apiInstance.post('/ckyc/get_otp', payload)
  return response
}